export default "__VITE_ASSET__Oewmx7u0__"